import SelectClients from '../components/Selects/SelectClients';
import Datepicker from '../components/Inputs/Datepicker/Datepicker';
import SelectContainers from '../components/Selects/SelectContainers';

export const dkpSignFilterOptions = [
  { name: 'clientId', component: SelectClients, label: 'Клиент', placeholder: 'Выберите клиента' },
  { name: 'createdAt', component: Datepicker, label: 'Дата', placeholder: 'дд-мм-гггг' },
  { name: 'dealId', label: 'Сделка', placeholder: 'ID сделки' },
  { name: 'carId', component: SelectContainers, label: 'Автомобиль', placeholder: 'Выберите авто' },
]; 